import { computed, type Ref } from 'vue';
import type { EmptyNumberValue } from '../types';
import { isNil } from '../helpers';

// это согласовано с А.Колбасовым в рамках https://jira.baltbet.ru:8443/browse/WEB-9788
// чтобы не было путаницы для любых форматов в ПОЛЕ ВООДА:
// - разделитель дроби - ТОЛЬКО точка (как в машинном языке)
// - разделитель тысяч - ТОЛЬКО пробел
const formatter = new Intl.NumberFormat('ru-RU', {
    useGrouping: true,
    maximumFractionDigits: 2,
});

const replaceDecimalSeparator = (value: string) => value.replace(',', '.')

const ONLY_DECIMAL_CHARS = new RegExp(`[^\\d\\.]`, 'g');

const useProxyNumberToString = (
    realValue: Ref<number | undefined>,
    emptyNumberValue: EmptyNumberValue = undefined,
    useFormat: boolean = false
) => {
    return computed<string>({
        get: () => {
            if (isNil(realValue.value)) return '';

            if (useFormat) {
                return replaceDecimalSeparator(formatter.format(realValue.value));
            }

            return String(realValue.value);
        },
        set: (newStringValue: string) => {
            if (!newStringValue) {
                realValue.value = emptyNumberValue;
                return;
            }

            if (useFormat) {
                // Убираем все символы кроме цифр и десятичного разделителя
                newStringValue = newStringValue.replace(ONLY_DECIMAL_CHARS, '');

                if (!newStringValue) {
                    realValue.value = emptyNumberValue;
                    return;
                }

                newStringValue = replaceDecimalSeparator(newStringValue);
            }

            const newNumberValue = parseFloat(newStringValue);

            if (Number.isNaN(newNumberValue)) {
                realValue.value = emptyNumberValue;
                return;
            }

            realValue.value = newNumberValue;
        }
    });
};

export {
    useProxyNumberToString,
}
